import { useMutation } from '@tanstack/react-query';
import { previewFieldBindings } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';
import { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { isStandardBackendError } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';
import { PreviewRes } from '@dealstack/frontend/shared/components/FieldBinding/fieldBinding.types.ts';

interface Params {
	templateId: string;
	investorId: string;
}

export const useFieldBindingPreview = () => {
	const tDefault = useTranslationDefault();
	const { dealId, mipId } = useRequiredParams('dealId', 'mipId');

	return useMutation({
		mutationFn: async (params: Params): Promise<PreviewRes> => {
			if (!params.templateId) {
				throw new Error('Template ID not found');
			}
			return await previewFieldBindings({
				dealId,
				programmeId: mipId,
				templateId: params.templateId,
				investorId: params.investorId,
			});
		},
		onError: (error: unknown) => {
			if (isStandardBackendError(error)) {
				showToastV2({
					state: 'error',
					title: tDefault(`error_codes.${error.error?.code}`),
				});
				return;
			}
			const backendMessage = (error as { error?: { message?: string } })?.error?.message;
			if (typeof backendMessage === 'string' && backendMessage.length > 0) {
				showToastV2({
					state: 'error',
					title: backendMessage,
				});
				return;
			}
			showToastV2({
				state: 'error',
				title: tDefault('common.toast.error.message'),
			});
		},
	});
};
